import {
  usePlayersStore,
  useSessionStore,
  useVotingStore,
} from "@/stores";
export function handleLock([seatIndex, isForced]: [number, number]) {
  const playersStore = usePlayersStore();
  const session = useSessionStore();
  const votingStore = useVotingStore();
  if (!session.isPlayerOrSpectator) return;
  votingStore.lockVote(seatIndex);
  if (seatIndex <= 1) { return; }
  const { lockedVote, nomination, votes } = votingStore;
  const index =
    ((typeof nomination?.nominee === "number"
      ? nomination.nominee
      : (nomination?.nominator as number) || 0) +
      lockedVote -
      1) %
    playersStore.players.length;
  if (votes[index] !== isForced) {
    votingStore.vote([index, isForced]);
  }
}
